<script lang="ts">
    import { type Snippet, onMount, tick } from 'svelte';
    import type { TileListInitialSession } from '@tilelist/application/core/TileListInitialSession.ts';
    import type {
        BrowserLifecycle,
        BrowserLifecycleFactory,
    } from '@tilelist/application/wiring/BrowserLifecycle.browser.ts';
    import { createAndProvideWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import type { ProductItem, TileItem } from '@tilelist/domain/composition/TileListitem.ts';
    import type { TileListPageLayout } from '@tilelist/domain/composition/TileListPage';

    export type TileListControllerRenderProps = {
        page: TileListPageLayout | null;
        cacheRestored: boolean;
        onRedirectToPdp(item: TileItem): void;
        onProductItemUpdated(item: ProductItem): void;
    };

    const {
        initialSession,
        createBrowserLifecycle,
        children,
    }: {
        initialSession: TileListInitialSession;
        createBrowserLifecycle: BrowserLifecycleFactory;
        children: Snippet<[TileListControllerRenderProps]>;
    } = $props();

    /*                                     */
    const wiringCtx = createAndProvideWiring(initialSession);

    /*                                     */
    const state: { page: TileListPageLayout | null; cacheRestored: boolean } = $state({
        page: initialSession.page,
        cacheRestored: false,
    });
    let lifecycle: BrowserLifecycle | undefined;

    onMount(() => {
        lifecycle = createBrowserLifecycle({
            initialSession,
            state,
            wiring: wiringCtx,
            afterRender: tick,
        });
        lifecycle.start();
        return () => lifecycle?.dispose();
    });

    /**
 *
 *
 */

    function onRedirectToPdp(item: TileItem) {
        lifecycle?.redirectToPdp(item);
    }

    function onProductItemUpdated(item: ProductItem) {
        lifecycle?.updateProduct(item);
    }
</script>

{@render children({ page: state.page, cacheRestored: state.cacheRestored, onRedirectToPdp, onProductItemUpdated })}
